import Error from "assets/icons/Error.svg";
import Info from "assets/icons/Info.svg";
import Success from "assets/icons/Success.svg";
import Warning from "assets/icons/Warning.svg";
import { CustomNotification } from "global/components";
import strings from "global/constants/StringConstants";
import { Component } from "react";
import { globalEmitter } from "utils/emitter";

class Notifications extends Component {
  state = {
    showNotification: false,
    variant: strings.success,
    icon: <></>,
    title: "",
    message: "",
  };

  defaultSuccessIcon = (<img src={Success} />);
  defaultWarningIcon = (<img src={Warning} />);
  defaultErrorIcon = (<img src={Error} />);
  defaultInfoIcon = (<img src={Info} />);

  renderElement: JSX.Element = (<></>);

  componentDidMount() {
    globalEmitter.addListener(
      strings.notification,
      this.handleNotificationEmitted
    );
  }

  componentWillUnmount() {
    globalEmitter.removeListener(
      strings.notification,
      this.handleNotificationEmitted
    );
  }

  handleClose = () => {
    this.setState({ showNotification: false });
  };

  handleNotificationEmitted = (event: {
    type: string;
    message: string;
    title: string;
  }) => {
    switch (event.type) {
      case strings.info:
        this.openInfoNotification(event.message, event.title);
        break;
      case strings.success:
        this.openSuccessNotification(event.message, event.title);
        break;
      case strings.warning:
        this.openWarningNotification(event.message, event.title);
        break;
      case strings.error:
        this.openErrorNotification(event.message, event.title);
        break;
      default:
        break;
    }
    this.setState({ showNotification: true });
  };

  autoHideNotification = (duration: number) => {
    // Seconds
    setTimeout(() => {
      this.handleClose();
    }, duration * 1000);
  };

  openInfoNotification = (message: string, title: string) => {
    this.setState({
      showNotification: true,
      variant: strings.info,
      title: title,
      message: message,
      icon: this.defaultInfoIcon,
    });
    this.autoHideNotification(7);
  };

  openSuccessNotification = (message: string, title: string) => {
    this.setState({
      showNotification: true,
      variant: strings.success,
      title: title,
      message: message,
      icon: this.defaultSuccessIcon,
    });
    this.autoHideNotification(7);
  };

  openWarningNotification = (message: string, title: string) => {
    this.setState({
      showNotification: true,
      variant: strings.warning,
      title: title,
      message: message,
      icon: this.defaultWarningIcon,
    });
    this.autoHideNotification(7);
  };

  openErrorNotification = (message: string, title: string) => {
    this.setState({
      showNotification: true,
      variant: strings.error,
      title: title,
      message: message,
      icon: this.defaultErrorIcon,
    });
    this.autoHideNotification(7);
  };

  render() {
    return (
      <CustomNotification
        showNotification={this.state.showNotification}
        verticalPosition="top"
        horizontalPosition="right"
        variant={this.state.variant}
        title={this.state.title}
        message={this.state.message}
        icon={this.state.icon}
        handleClose={this.handleClose}
      />
    );
  }
}

export default Notifications;
